export default __webpack_public_path__ + "static/media/TCLogo.48a29fa9.png";